import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   * Minus button is never disabled in cart — at min quantity it removes the item
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const effectiveMax = this.getEffectiveMax();

    // Minus is always enabled in cart — at min it triggers removal (qty 0)
    minusButton.disabled = false;
    plusButton.disabled = effectiveMax !== null && this.getCurrentValues().value >= effectiveMax;
  }

  /**
   * Override decrease to remove item when at minimum quantity
   * @param {Event} event
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();

    const { min, value } = this.getCurrentValues();

    if (value <= min) {
      // At or below minimum — set to 0 to trigger removal
      this.refs.quantityInput.value = '0';
      this.onQuantityChange();
    } else {
      this.updateQuantity(-1);
    }
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
